import { validateNumber } from 'ember-changeset-validations/validators';

export const SecurityDepositActionValidation = {
  amount: [
    validateNumber({ gte: 0 }),
    function (
      _field,
      newAmount,
      _oldAmount,
      _content,
      changeset,
    ): undefined | 'error' {
      const depositAmount = changeset.booking?.securityDeposit?.amount ?? 0;

      if (depositAmount >= Number(newAmount)) {
        return;
      }

      // if validation function returns string - it means that validation failed
      return 'error';
    },
  ],
};
